import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { messages } from "utils/CommonConstants";
import { deleteNotifications } from "./Notifications.slice";

interface Prop {
  openDeleteDialog: boolean;
  setOpenDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Delete(props: Prop) {
  const dispatch = useAppDispatch();
  const { openDeleteDialog, setOpenDeleteDialog } = props;
  const notifications = useAppSelector((state) => state.Notifications.data.list);

  const deleteHandler = () => {
    const notificationIds = notifications.map((item: any) => item.id).join(",");
    dispatch(deleteNotifications({ notificationIds }));
    setOpenDeleteDialog(false);
  };

  const handleCloseDialog = () => {
    setOpenDeleteDialog(false);
  };

  return (
    <>
      {openDeleteDialog && (
        <DialogFormation
          title="Delete Notifications"
          openDialog={openDeleteDialog}
          handleClose={handleCloseDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={handleCloseDialog} width="25%" />
              <Button label="Proceed" width="25%" onClick={deleteHandler} />
            </div>
          }
        >
          <div className="text-center">{messages.deleteNotifications}</div>
        </DialogFormation>
      )}
    </>
  );
}
